const MASTER_ROLES = new Set(['ceo', 'master', 'admin', 'super_admin'])

export const STANDARD_ACCESS_OPTIONS = ['Administrator', 'Counsellor']

export const ACCESS_LABEL_TO_ROLE_NAME = {
	Administrator: 'admin',
	Counsellor: 'counselor',
}

export function mapRoleToAccessLabel(roleName) {
	const role = String(roleName || '')
		.trim()
		.toLowerCase()
	if (MASTER_ROLES.has(role)) return 'Administrator'
	if (role === 'counselor' || role === 'counsellor') return 'Counsellor'
	if (role === 'viewer') return 'Counsellor'
	if (!role) return 'Counsellor'
	return role.charAt(0).toUpperCase() + role.slice(1)
}

export function getAccessOptionsFromRoles(_roles = []) {
	// User Management always offers the standard access levels.
	// Role ids for save operations are resolved separately.
	return STANDARD_ACCESS_OPTIONS
}

export function resolveRoleIdForAccessLabel(roles = [], accessLabel) {
	const preferred = ACCESS_LABEL_TO_ROLE_NAME[accessLabel]
	if (!preferred) {
		throw new Error(`Unknown access level: ${accessLabel}`)
	}
	const match = roles.find(role => {
		const name = String(role?.name || '')
			.trim()
			.toLowerCase()
		return name === preferred || (preferred === 'counselor' && name === 'counsellor')
	})
	if (!match) {
		throw new Error(`Role "${preferred}" is not available for this organization`)
	}
	return match.id
}

/**
 * Project a studentsStore row into the User Management table shape.
 * Does not mutate studentsStore.
 */
export function toUserManagementStudent(student) {
	const counselorId = student?.counselorId || null
	const counselorName = String(student?.counselor || '').trim()
	const isAssigned = Boolean(counselorId)
	return {
		id: student.id,
		name: student.name,
		grade: student.gradeLabel || String(student.grade ?? ''),
		plan: student.plan || 'Essential',
		kandorPlan: student.kandorPlan || 'free',
		counselor: isAssigned
			? counselorName && counselorName !== 'Current Counselor'
				? counselorName
				: counselorName || 'Assigned'
			: 'Unassigned',
		counselorId,
		assignments: Number(student.assignmentsCount ?? student.assignments ?? 0),
		avatarKey: student.avatarKey,
		photoUrl: student.photoUrl,
		disabled: Boolean(student.disabled),
	}
}
